import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import Cropper from 'cropperjs';
import { GlobalService } from './global.service';
import { CloudinaryUploader } from './cloudinary-uploader.service';


@Injectable()
export class ImagesService {

  cl = new CloudinaryUploader( );

  constructor ( private global: GlobalService ) { 
    
  }

  // ToDo not working in Chrome for Windows
  changeImageHandler ( $event, $previewSelector, entity, disableDestroy?, cb? ) {
    let data = {
      inputValue: $event.target,
      previewSelector: $previewSelector,
      opts: {},
      callback: ( response ) => {
        entity.attachment = response.secure_url;
        if( cb ) {
          cb( entity.attachment );
        }
      }
    };
    if ( entity.attachment_public_id != '' ) {
      data.opts['public_id'] = entity.attachment_public_id;
      if ( disableDestroy != true ) {
        this.destroyImage( entity.attachment_public_id, ( ) => {
          entity.attachment = '';
          entity.attachment_public_id = '';
          this.changeImage( data );
        });
      }
    } else {
      this.changeImage( data );
    }
  }

  errorMessage ( message ) {
    let messageData = {
      title: 'Error!',
      html: message || '', 
      showConfirmButton: true
    };
    this.global.errorMessage( messageData );
  }

  changeImage ( data: any ) {
    // let preview = $( data.$previewSelector );
    this.global.showPreloader( );
    let file: File = data.inputValue.files[0];
    let reader: FileReader = new FileReader( );
    let validImage: boolean = false;
    reader.onloadend = ( ) => {
      this.uploadImage( reader.result, data.opts, ( response ) => {
        this.global.hidePreloader( );
        data.callback( response );
      });
      // preview.attr( 'src', reader.result );
      // if ( preview.attr( 'src' ) && !this.cropperInited ) {
      //   this.cropperInited = true;
      //   this.cropper.initCropper( preview.get( 0 ) );
      // }
    };
    validImage = this.checkValidImage( file );
    if ( !validImage ) return;
    reader.readAsDataURL( file );
  }

  checkValidImage ( file ) {
    if ( !file ) { 
      this.global.hidePreloader( );
      return false; 
    }
    if ( !file.type.match( 'image.*' ) && !file.type.match( 'video.*' ) ) {
      this.errorMessage( 'Uploaded file is not an image/video' );
      this.global.hidePreloader( );
      return false;
    }
    if ( file.size > 1024 * 1024 * 10 ) {  // > 10MB
      this.errorMessage( 'Image you trying to upload is larger than allowed 10MB. Please select another image' );
      this.global.hidePreloader( );
      return false;
    }
    return true;
  }

  uploadImage ( image_url, opts, cb ) {

    this.cl.upload( image_url, opts, ( result ) => { 
      cb( result );
    });
  }

  destroyImage ( public_id, cb ) {

    if ( public_id ) {
      this.cl.destroy( public_id, ( result ) => { 
        cb( result );
      });
    } else cb({ });
  }

  initCropper ( selector ) {

    let cropper = new Cropper( selector, {
      crop: ( e ) => {
        // Output the result data for cropping image.
      }
    });

  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/services/images.service.ts